import { inject, Injectable } from '@angular/core'
import { TranslocoService } from '@jsverse/transloco'
import { MessageService } from 'primeng/api'
import { ResultCRUD, ToastSeverity } from '../../models/functional/toastState'

@Injectable({
  providedIn: 'root',
})
export class PrimeNgToastService {
  private readonly translocoService = inject(TranslocoService)
  private readonly messageService = inject(MessageService)

  displayCrudToast(result: ResultCRUD, prefix: string): void {
    this.messageService.add({
      severity: result.status,
      summary: this.translocoService.translate(this.getSummaryKey(result.status)),
      detail: this.translocoService.translate(
        `${prefix}.CRUD.${result.action.toUpperCase()}.${result.status.toUpperCase()}`,
      ),
    })
  }

  displayErrorToast(detailKey: string): void {
    this.displayCustomToast('error', detailKey)
  }

  displayCustomToast(severity: ToastSeverity, detailKey: string): void {
    this.messageService.add({
      severity,
      summary: this.translocoService.translate(this.getSummaryKey(severity)),
      detail: this.translocoService.translate(detailKey),
    })
  }

  displayCustomToastWithParams(
    severity: ToastSeverity,
    detailKey: string,
    params?: Record<string, unknown>,
  ): void {
    this.messageService.add({
      severity,
      summary: this.translocoService.translate(this.getSummaryKey(severity)),
      detail: this.translocoService.translate(detailKey, params ?? {}),
      life: 6000,
    })
  }

  private getSummaryKey(severity: ToastSeverity): string {
    return `TOAST.${severity.toUpperCase()}`
  }
}
